var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoggedInUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 28",
    fill: "#343434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n  .a {\n  fill: #343434;\n  }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.268,24.836c-.888-1.772-3.8-2.841-7.83-4.325L21.4,20.132a.988.988,0,0,1-.227-.512,4.238,4.238,0,0,1,.1-2.141,9.253,9.253,0,0,0,2.415-7.105c0-3.981-2.6-6.873-6.186-6.873s-6.186,2.892-6.186,6.875a9.232,9.232,0,0,0,2.39,7.082,4.04,4.04,0,0,1,.12,2.168,1.013,1.013,0,0,1-.222.509l-1.043.377c-4.03,1.482-6.942,2.553-7.83,4.325A15.108,15.108,0,0,0,3.5,30.676a.824.824,0,0,0,.824.824H30.676a.824.824,0,0,0,.824-.824,15.109,15.109,0,0,0-1.232-5.84Z",
    transform: "translate(-3.5 -3.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggedInUser);
export default __webpack_public_path__ + "static/media/logged-in-user.9994fbf2.svg";
export { ForwardRef as ReactComponent };